// src/components/kanban/AssigneeAvatars.tsx
/**
 * Gruppo di avatar per gli assegnatari di un task Kanban, con overflow "+N" e tooltip.
 * Nessun avatar visibile se non ci sono assegnatari (stessa scelta del vecchio KanbanCard,
 * che nascondeva semplicemente l'avatar quando non c'era un utente assegnato).
 */
import { Avatar, Tooltip } from '@mantine/core';
import type { TaskAssignee } from '../../types/api';

interface AssigneeAvatarsProps {
  assignees: TaskAssignee[];
  max?: number;
  size?: number;
}

function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export default function AssigneeAvatars({ assignees, max = 3, size = 26 }: AssigneeAvatarsProps) {
  if (!assignees || assignees.length === 0) {
    return null;
  }

  const visible = assignees.slice(0, max);
  const rest = assignees.slice(max);

  return (
    <Avatar.Group>
      <Tooltip.Group openDelay={300} closeDelay={100}>
        {visible.map((a) => (
          <Tooltip key={a.userId} label={a.fullName} withArrow>
            <Avatar
              size={size}
              radius="xl"
              color={a.colorTag ? undefined : 'blue'}
              style={a.colorTag ? { backgroundColor: a.colorTag, color: '#fff' } : undefined}
            >
              {initials(a.fullName)}
            </Avatar>
          </Tooltip>
        ))}
        {rest.length > 0 && (
          <Tooltip label={rest.map((a) => a.fullName).join(', ')} withArrow>
            <Avatar size={size} radius="xl">
              +{rest.length}
            </Avatar>
          </Tooltip>
        )}
      </Tooltip.Group>
    </Avatar.Group>
  );
}
